import {apiAxios} from '@config/axios'

import type {User} from '@app-types/api'

export const getUserDetails = () => apiAxios.get<User>('/me/').then(r => r.data)

export const login = async (credentials: {username: string; password: string}) => {
  await apiAxios.get('/auth/csrf/') // sets the csrftoken cookie
  return apiAxios.post('/auth/login/', credentials).then(r => r.data)
}

export const logout = () => apiAxios.post('/auth/logout/').then(r => r.data)

export const changePassword = (body: {current: string; new: string}) => apiAxios.post('/auth/password/', body).then(r => r.data)
